import { render, staticRenderFns } from "./SelfReportedEmployeeUnclaimed.vue?vue&type=template&id=6b44fab5"
import script from "./SelfReportedEmployeeUnclaimed.vue?vue&type=script&lang=ts"
export * from "./SelfReportedEmployeeUnclaimed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports